import { toast, ToastOptions } from "react-toastify";

type ToastHandler = (body: unknown, options?: ToastOptions) => void;

let toastsSuppressed = false;

export const setToastsSuppressed = (suppressed: boolean) => {
    toastsSuppressed = suppressed;
    if (suppressed) {
        toast.dismiss();
        toast.clearWaitingQueue();
    }
};

const showToast: ToastHandler = (body, options) => {
    if (toastsSuppressed) {
        return;
    }
    const message = typeof body === "string" ? body : "Unknown error occurred";
    toast(message, {
        pauseOnHover: true,
        pauseOnFocusLoss: true,
        draggable: false,
        ...options,
    });
};

export const showSuccessToast: ToastHandler = (body, options) => {
    showToast(body, {
        type: "success",
        autoClose: 1000,
        ...options,
    });
};

export const showWarningToast: ToastHandler = (body, options) => {
    showToast(body, {
        type: "warning",
        autoClose: 2800,
        ...options,
    });
};

export const showErrorToast: ToastHandler = (body, options) => {
    showToast(body, {
        type: "error",
        autoClose: 8200,
        ...options,
    });
};
